import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { takeLatest, put } from 'redux-saga/effects';
import getJson from '../../../network/get-json';
import { showStopMessage } from '../../stop-message/actions';
import getString from '../../../strings/get-string';
import getNuanceNavigationItem from './support/get-nuance-navigation-item';
import logger from '../../../logger/logger';
import * as actions from '../actions';
var watchNuanceNavigationRequest = /*#__PURE__*/regeneratorRuntime.mark(function watchNuanceNavigationRequest() {
  return regeneratorRuntime.wrap(function watchNuanceNavigationRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(actions.NAVIGATION_REQUEST_NUANCE, /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
            var payload, url, nuanceNavigation, navigationResponse, navigationItem, globalMessages, message;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    payload = _ref.payload;
                    url = payload.url, nuanceNavigation = payload.nuanceNavigation;
                    _context.prev = 2;
                    navigationResponse = {};

                    if (!nuanceNavigation) {
                      _context.next = 24;
                      break;
                    }

                    if (!(typeof nuanceNavigation === 'string')) {
                      _context.next = 11;
                      break;
                    }

                    _context.next = 8;
                    return getJson({
                      url: url,
                      includeRootContext: false,
                      params: {
                        identifier: nuanceNavigation
                      }
                    });

                  case 8:
                    navigationResponse = _context.sent;
                    _context.next = 19;
                    break;

                  case 11:
                    if (!(_typeof(nuanceNavigation) === 'object')) {
                      _context.next = 19;
                      break;
                    }

                    if (!(nuanceNavigation.displayType === 'saml')) {
                      _context.next = 18;
                      break;
                    }

                    _context.next = 15;
                    return getJson({
                      url: url,
                      includeRootContext: false,
                      params: {
                        identifier: nuanceNavigation.identifer
                      }
                    });

                  case 15:
                    navigationResponse = _context.sent;
                    _context.next = 19;
                    break;

                  case 18:
                    navigationResponse = nuanceNavigation;

                  case 19:
                    navigationItem = getNuanceNavigationItem(navigationResponse);
                    _context.next = 22;
                    return put(actions.requestNavigation(navigationItem));

                  case 22:
                    _context.next = 27;
                    break;

                  case 24:
                    logger.error('Failed to load navigation configuration for nuance');
                    _context.next = 27;
                    return put(showStopMessage(getString('global.service.unavailable'), getString('global.system.unavailable.heading')));

                  case 27:
                    _context.next = 35;
                    break;

                  case 29:
                    _context.prev = 29;
                    _context.t0 = _context["catch"](2);
                    globalMessages = _context.t0.FailureMessageBean && _context.t0.FailureMessageBean.globalMessages || [{}];
                    message = globalMessages[0].message || getString('global.service.unavailable');
                    _context.next = 35;
                    return put(showStopMessage(message, getString('global.system.unavailable.heading')));

                  case 35:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 29]]);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, watchNuanceNavigationRequest);
});
export default watchNuanceNavigationRequest;